module.exports = __webpack_public_path__ + "img/ie.4b3b59e7.svg";